export default "__VITE_ASSET__9105cdbe__"